import {toAbsoluteUrl} from '_metronic/helpers'

/**
 * The locales the portal ships, in the order they are offered.
 *
 * Each `name` is written in its own language/script — that is what a speaker
 * scanning for their language actually recognises, and it is why the list is
 * NOT run through i18n.
 *
 * Shared so the header user-menu switcher and the applicant-facing admission
 * switcher cannot drift apart on which locales exist or what they are called.
 * Keep in step with LOCALES in scripts/i18n/*.mjs and the messages/ folders.
 */
export type LanguageOption = {
  lang: string
  name: string
  flag: string
}

export const languages: LanguageOption[] = [
  {
    lang: 'ar',
    name: 'عربي',
    flag: toAbsoluteUrl('/media/flags/united-arab-emirates.svg'),
  },
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
  {
    lang: 'fr',
    name: 'Français',
    flag: toAbsoluteUrl('/media/flags/france.svg'),
  },
  {
    lang: 'tr',
    name: 'Türkçe',
    flag: toAbsoluteUrl('/media/flags/turkey.svg'),
  },
  {
    lang: 'ur',
    name: 'اردو',
    flag: toAbsoluteUrl('/media/flags/pakistan.svg'),
  },
]
